import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

export interface FileData {
  id?: string;
  nomeArquivo: string;
  base64: string;
}

export interface FileAction {
  icon: string;
  label: string;
  disabled?: boolean;
  action: (file: FileData) => void;
}

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class FileComponent {
  @Input()
  file: FileData = { nomeArquivo: '', base64: '' };

  @Input()
  actions: FileAction[] = [];

  exibirAction: boolean = false;

  get type(): string {
    return this.file.base64.split(';')[0].split(':')[1] || '';
  }

  constructor() {}

  ngOnInit(): void {}
}
